import { defaultColor, defaultOutlineColor, defaultOutlineSize } from "shared/map/domain/style";
import type { ShapeResponse } from "../api/models/shapeResponse";
import { setStorageAreaId, setShapeId } from "shared/shapes/domain/shapeGeoJson";

export function processShape(response: ShapeResponse) {
  const {
    geofenceGeoJson, shapeGeoJson, storageAreaId, id
  } = response;

  if (shapeGeoJson)
  {
    shapeGeoJson.id = id;

    if (storageAreaId !== null)
    {
      setStorageAreaId(shapeGeoJson, storageAreaId);
    }

    setShapeId(shapeGeoJson, id);

    defaultColor(shapeGeoJson, '#fafafa');
    defaultOutlineColor(shapeGeoJson, '#000000');
    defaultOutlineSize(shapeGeoJson, 1);

  }

  if (geofenceGeoJson)
  {
    geofenceGeoJson.id = `geofence_${id}`;
    setShapeId(geofenceGeoJson, id);
  }
}
